import * as React from "react";

import {
    Create,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
} from "react-admin";




const validateUserCreation = (values) => {
    const errors = {};
    if (values.password !== values.confirmPassword) {
        errors.password = "Passwords do not match";
        errors.confirmPassword = "Passwords do not match";
    }

    return errors;
};


export const CategoryCreate = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify(`Element Created`);
        redirect("/categories");
        refresh();
    };

    const onFailure = (error) => {
        notify(`Could not edit Category: ${error.message}`);
        refresh();
    };
    
    return (
        <Create mutationMode="pessimistic" undoable={false} onSuccess={onSuccess} onFailure={onFailure} {...props}>
            <SimpleForm validate={validateUserCreation}>
                <>
                    <div className="category_feild">
                        <h2>Add New Category</h2>
                        <TextInput fullWidth={true} label="category_name" source="category_name" />
                    </div>
                </>
            </SimpleForm>
        </Create>
    );
};

